module.exports = __webpack_public_path__ + "img/is-open.976270cc.png";